// removed by extract-text-webpack-plugin
module.exports = {"title":"hobnob-modal__title__3cWsp","cancel-button-container":"hobnob-modal__cancel-button-container__k16bU","cancel-icon-wrapper":"hobnob-modal__cancel-icon-wrapper__19k5X","cancel-icon":"hobnob-modal__cancel-icon__3lxwp","content":"hobnob-modal__content__Mel7A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/hobnob-modal.scss
// module id = 1234
// module chunks = 1